import { FC, useMemo } from "react";
import { useLocation } from "react-router-dom";
import qs from "query-string";
import { DocumentTypes, iDocumentQueryParams } from "./DocumentView.helpers";
import MacSwitch from "./DocumentTypes/MacSwitch/MacSwitch";
import Document from "./DocumentTypes/Document";
import "./DocumentView.styles.scss";

interface iProps {}
const DocumentView: FC<iProps> = () => {
    const location = useLocation();
    const params = useMemo(() => qs.parse(location.search) as unknown as iDocumentQueryParams, [location.search]);
    const isMac = useMemo(() => params.doctype === `${DocumentTypes.mac}`, [params.doctype]);

    return (
        <>
            {isMac && <MacSwitch/>}
            {!isMac && <Document />}
        </>
    );
};

export default DocumentView;
